import {
  Box,
  Flex,
  IconButton,
  Tooltip, // <-- Add this import
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { AiOutlineMenu } from "react-icons/ai"; // <-- Use AiOutlinePoweroff
import { FiLogOut } from "react-icons/fi";
import MobileSidebar from "./MobileSidebar";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";

const MobileHeader = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signOut = () => {
    dispatch(removeUser());
    navigate("/");
  };

  return (
    <Flex
      h="5rem"
      bg="white"
      px={4}
      alignItems={"center"}
      position={"sticky"}
      top={0}
      zIndex={200}
      boxShadow={"0px 2px 10px 0px rgba(198, 198, 198, 0.25)"}
      justifyContent={"space-between"}
      display={["flex", "flex", "flex", "none"]}
    >
      <IconButton
        px={0}
        minW={"auto"}
        onClick={onOpen}
        icon={<AiOutlineMenu />}
        bg="transparent"
        _hover={{ bg: "transparent" }}
        _active={{ bg: "transparent" }}
      />

      <Tooltip label="Log out" placement="bottom" hasArrow>
        <span>
          <Box
            position={"relative"}
            onClick={signOut}
            cursor={"pointer"}
            aria-label="Log out"
            tabIndex={0}
            role="button"
          >
            <FiLogOut size={"1.5rem"} />
          </Box>
        </span>
      </Tooltip>

      <MobileSidebar btnRef={btnRef} isOpen={isOpen} onClose={onClose} />
    </Flex>
  );
};

export default MobileHeader;
